/* eslint-disable max-len */
export default {
    menu: {
        pause: 'Pause simulation',
        switchAirport: 'Switch airport',
        fixesRunways: 'Fixes & Runways',
        sidDisplay: 'SID display',
        starDisplay: 'STAR display',
        airspaceDepiction: 'Airspace Depiction',
        restrictedAreas: 'Restricted Areas',
        terrain: 'Terrain',
        videoMaps: 'Video Maps',
        settings: 'Settings',
        speech: 'Speech',
        traffic: 'Traffic',
        airportGuide: 'Airport Guide',
        commands: 'Commands',
        tutorial: 'Tutorial',
        score: 'Score',
        timeWarp2: 'Set time warp to 2',
        timeWarp5: 'Set time warp to 5',
        timeWarp1: 'Set time warp to 1'
    },
    dialog: {
        settings: 'Settings',
        traffic: 'Traffic rate',
        videoMaps: 'Video Maps',
        selectAirport: 'Select Airport',
        searchAirports: 'search airports'
    },
    command: {
        aircraftPlaceholder: 'enter aircraft command',
        scopePlaceholder: 'enter scope command'
    },
    autocomplete: {
        legend: 'Legend: <b>alias</b> | <u>argument</u> | <i>optional</i>',
        navigate: '[↑/↓] to navigate',
        select: '[tab] to select',
        commit: '[tab] to commit',
        revert: '[esc] to go back',
        cancel: '[esc] to cancel',
        inputCommand: 'search commands',
        inputParam: 'input arguments'
    },
    tutorial: {
        previousStep: 'Previous step',
        nextStep: 'Next step',
        loadError: 'The tutorial failed to load: {error}'
    },
    traffic: {
        windDirection: 'wind direction',
        windSpeed: 'wind speed',
        default: 'Default',
        restart: 'Restart',
        categories: {
            arrival: 'arrival',
            departure: 'departure',
            overflight: 'overflight'
        }
    },
    settings: {
        options: {
            language: {
                description: 'Interface language',
                options: {
                    en: 'English',
                    ru: 'Русский'
                }
            },
            towerController: {
                description: 'Tower Control (Experimental)',
                options: {
                    SYSTEM: 'System Controlled',
                    USER: 'User Controlled'
                }
            },
            controlMethod: {
                description: 'Control Method',
                options: {
                    classic: 'Classic',
                    arrows: 'Arrow Keys'
                }
            },
            drawIlsDistanceSeparator: {
                description: 'Show trailing separation indicator on ILS',
                options: {
                    'from-theme': 'From Theme',
                    yes: 'Yes',
                    no: 'No'
                }
            },
            ptlLengths: {
                description: 'Projected Track Line (PTL) increments, in minutes',
                options: {
                    '0.5-1-1.5-2-2.5-3-3.5-4-4.5-5-5.5-6-6.5-7-7.5-8': '0.5 x n ... 8',
                    '1-2-3-4-5-6-7-8': '1.0 x n ... 8',
                    '1-2-4-6-8-10-12-14-16': '1-2-4-6-8-10-12-14-16',
                    '0.5-1-2-4-8': '0.5-1-2-4-8',
                    '1-2-4-8': '1-2-4-8'
                }
            },
            drawProjectedPaths: {
                description: 'Draw aircraft projected path',
                options: {
                    always: 'Always',
                    selected: 'Selected',
                    never: 'Never'
                }
            },
            softCeiling: {
                description: 'Allow departures via climb',
                options: {
                    yes: 'Yes',
                    no: 'No'
                }
            },
            mouseClickDrag: {
                description: 'Panning Button',
                options: {
                    left: 'Left Click',
                    right: 'Right Click'
                }
            },
            rangeRings: {
                description: 'Range rings',
                options: {
                    default: 'Default',
                    off: 'Off',
                    1: '1 nm',
                    2: '2 nm',
                    5: '5 nm',
                    10: '10 nm',
                    15: '15 nm',
                    20: '20 nm'
                }
            },
            measureToolPath: {
                description: 'Measure path style',
                options: {
                    0: 'Straight lines only',
                    1: 'Arc to next fix, then straight',
                    2: 'All lines arced'
                }
            },
            chatLogDuration: {
                description: 'Chat Log Duration'
            }
        }
    },
    quickCommands: {
        ils: 'ILS approach',
        dvs: 'DVS',
        cvs: 'CVS',
        taxi: 'Taxi',
        caf: 'CAF',
        takeoff: 'Takeoff',
        noSelection: 'No aircraft selected',
        notUnderstood: 'Command not understood'
    },
    commandsReference: {
        title: 'Commands',
        intro: 'Enter aircraft commands with the callsign first. Several commands can be chained in one transmission.',
        scopeHint: 'Press ` (backquote) to switch between aircraft and scope commands.',
        callsign: 'CALLSIGN',
        sections: {
            departure: 'Departure',
            arrival: 'Arrival',
            routing: 'Routing',
            control: 'Control',
            query: 'Queries',
            system: 'System',
            scope: 'Scope'
        },
        items: {
            caf: {
                name: 'Cleared as filed',
                desc: 'Clears the aircraft to fly the filed route and SID.'
            },
            cvs: {
                name: 'Climb via SID',
                desc: 'Authorizes climb in accordance with SID restrictions.'
            },
            takeoff: {
                name: 'Takeoff',
                desc: 'Clears the aircraft for takeoff.'
            },
            taxi: {
                name: 'Taxi / wait',
                desc: 'Clears the aircraft to taxi or hold short.'
            },
            expectRunway: {
                name: 'Expect runway',
                desc: 'Advises the expected arrival runway.'
            },
            dvs: {
                name: 'Descend via STAR',
                desc: 'Authorizes descent in accordance with STAR restrictions.'
            },
            ils: {
                name: 'ILS approach',
                desc: 'Clears the aircraft for an ILS approach to the specified runway.'
            },
            direct: {
                name: 'Proceed direct',
                desc: 'Clears the aircraft direct to a fix.'
            },
            hold: {
                name: 'Hold',
                desc: 'Issues a holding pattern at a fix.'
            },
            exitHold: {
                name: 'Exit hold',
                desc: 'Cancels the holding pattern and resumes route.'
            },
            route: {
                name: 'Route',
                desc: 'Adds a fix to the route.'
            },
            reroute: {
                name: 'Reroute',
                desc: 'Replaces the route with a new one.'
            },
            sid: {
                name: 'SID',
                desc: 'Assigns or amends the departure procedure.'
            },
            star: {
                name: 'STAR',
                desc: 'Assigns or amends the arrival procedure.'
            },
            altitude: {
                name: 'Altitude',
                desc: 'Climb, descend, or maintain an altitude (in hundreds of feet).'
            },
            fph: {
                name: 'Fly present heading',
                desc: 'Instructs the aircraft to maintain current heading.'
            },
            heading: {
                name: 'Heading',
                desc: 'Turn left or right by the specified number of degrees.'
            },
            speed: {
                name: 'Speed',
                desc: 'Increase or decrease speed to the specified value in knots.'
            },
            cross: {
                name: 'Cross fix',
                desc: 'Cross a fix at the specified altitude and/or speed.'
            },
            sayAltitude: {
                name: 'Say altitude',
                desc: 'Requests the aircraft\'s current altitude.'
            },
            sayAssignedAltitude: {
                name: 'Say assigned altitude',
                desc: 'Requests the assigned altitude.'
            },
            sayHeading: {
                name: 'Say heading',
                desc: 'Requests the current heading.'
            },
            sayAssignedHeading: {
                name: 'Say assigned heading',
                desc: 'Requests the assigned heading.'
            },
            saySpeed: {
                name: 'Say speed',
                desc: 'Requests the current airspeed.'
            },
            sayAssignedSpeed: {
                name: 'Say assigned speed',
                desc: 'Requests the assigned speed.'
            },
            airport: {
                name: 'Switch airport',
                desc: 'Loads another airport.'
            },
            pause: {
                name: 'Pause',
                desc: 'Pauses or resumes the simulation.'
            },
            timewarp: {
                name: 'Timewarp',
                desc: 'Changes simulation speed.'
            },
            tutorial: {
                name: 'Tutorial',
                desc: 'Opens the tutorial.'
            },
            scratchpad: {
                name: 'Scratchpad',
                desc: 'Sets the scratchpad text on the data block.'
            },
            halo: {
                name: 'Halo',
                desc: 'Toggles the halo around the selected target.'
            },
            moveDataBlock: {
                name: 'Move data block',
                desc: 'Moves the leader line and data block (numpad direction).'
            }
        }
    }
};
